import { Box, styled } from '@mui/material';

const StepperRowColumn = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export default StepperRowColumn;
